import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: 'afea7fc6-4d53-4555-9e1e-0de34ca931f8',
	[AppLanguageCodes.SK]: 'afea7fc6-4d53-4555-9e1e-0de34ca931f8',
	[AppLanguageCodes.DE]: 'afea7fc6-4d53-4555-9e1e-0de34ca931f8',
}


export const TextBox = () => {

	return (
		<MdxDiv className='text-box' articleIds={articleIds}>
		</MdxDiv>
	);
};